import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from '../ui/Modal';

/**
 * "This event / All events" scope dialog for edits and deletes on a recurring
 * occurrence (Phase 4). Deliberately TWO options — "this and following" is
 * deferred, and the copy leaves room for it without a third button (owner-
 * approved line). Built on the shared Modal: ConfirmModal is a two-button
 * shape and this needs This/All/Cancel.
 */
export default function RecurrenceScopeDialog({ mode, eventTitle, onThis, onAll, onClose }) {
  const { t } = useTranslation();
  const editing = mode === 'edit';
  return (
    <Modal
      isOpen
      onClose={onClose}
      title={t(editing ? 'calendar.recurrence.scopeDialogTitleEdit' : 'calendar.recurrence.scopeDialogTitleDelete')}
      size="sm"
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10, fontSize: 13 }}>
        <p style={{ margin: 0 }}>
          {t(editing ? 'calendar.recurrence.scopeIntroEdit' : 'calendar.recurrence.scopeIntroDelete', {
            title: eventTitle || t('calendar.noTitle'),
          })}
        </p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          <button type="button" className="cal-btn" onClick={onThis}>
            {t('calendar.recurrence.scopeThis')}
          </button>
          <button type="button" className="cal-btn" onClick={onAll}>
            {t('calendar.recurrence.scopeAll')}
          </button>
        </div>
        {editing && (
          <span className="cal-editor-hint">
            {t('calendar.recurrence.scopeHint')}
          </span>
        )}
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <button type="button" className="cal-btn" onClick={onClose}>
            {t('common.cancel')}
          </button>
        </div>
      </div>
    </Modal>
  );
}
